<style lang="less" scoped>
.perCenter{
  margin: 0;
  padding: 0;
  // width: 1440px;
  // background:#fff;
  // margin:0 auto;
}
</style>
<template>
<div class="perCenter">
    <router-view></router-view>
</div>
</template>

<script>
// import contactsPeople from './Contacts'
export default {
  name: 'Class',
  components: {
    // contactsPeople
  },
  data () {
    return {

    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
